import fetch from './fetch';
import qs from 'Qs'
import { config } from 'shelljs';
// 注册接口
export function registerApi(options) {
  return fetch.post('/authority/register' , qs.stringify(options));
}

//登录
export function loginApi(options){
  return fetch.post('/authority/login',qs.stringify(options));
}

//获取用户信息
export function userInfoApi(){
  return fetch.get(`/user/info`)
}

//获取平台分类
export function platformListApi(){
  return fetch.get(`/platform/list`)
}

//创建任务
export function createTaskApi(options){
  return fetch.post('/platform/task',qs.stringify(options));
}

//发送短信
export  function sendSMS(phone,type){
  const res =  fetch.get(`/sms/sendRegisterCode?phone=${phone}&type=${type}`);
  return res; 
}

//任务状态
export function processApi(options){
  return fetch.post('/platform/process',qs.stringify(options))
}

export function taskSummaryApi(options){
  return fetch.post('/platform/view',qs.stringify(options))
}

export function taskDetailApi(options){
  return fetch.post('/platform/detail',qs.stringify(options))
}

export function closeTask(options){
  return fetch.post('/platform/closeTask',qs.stringify(options));
}

export function certApi(options){
  return fetch.post('/user/cert',qs.stringify(options));
}

export function getResultApi(options){
  return fetch.post('/platform/getResult',qs.stringify(options));
}
export function addAppointmentApi(options){
  return fetch.post('/appointment/add',qs.stringify(options));
}

export function appointmentListApi(){
  return fetch.post('/appointment/list');
}

export function messageApi(type){
  return fetch.get(`/msg/list?type=${type}`)
}

export function feedbackApi(options){
  return fetch.post('/feedback/add',qs.stringify(options))
}
export function editPwdApi(options){
  return fetch.post('/user/editPwd',qs.stringify(options))
}

export function logoutApi(){
  return fetch.get('/user/logout')
}

export function updateImgApi(options){
  return fetch.post('/authority/updateImg',qs.stringify(options))
}

export function createOrderApi(options){
  return fetch.post('/order/createOrder',qs.stringify(options))
}

export function packageListApi(){
  return fetch.post('/package/list')
}

export function orderCheckFApi(options){
  return fetch.post('/order/orderCheck',qs.stringify(options))
}

export function orderListApi(){
  return fetch.post('/order/orderList')
}

export function wxLoginApi(){
  return fetch.post('/authority/wxLogin')
}

export function updateUserNameApi(options){
  return fetch.post('/authority/updateUserName',qs.stringify(options))
}

export function resultDowApi(options){
  return fetch.post('/file/resultDow',qs.stringify(options))
}

export function orderDetailsApi(options){
  return fetch.post('/order/orderDetails',qs.stringify(options))
}



// WEBPACK FOOTER //
// ./src/service/allApi.js